<template>
    <div class="container-fluid" >
        <div class="row justify-content-between">
            <div class="col"><h3>Төлбөрийн мэдээлэл</h3></div>
       
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 my-3">
                        <div class="btn-group" role="group" >
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='paidcode'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='paidcode' }">Код</button>

                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group" >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Та хайх талбараа сонгоод хайх утгаа оруулаад хайх товч дээр дарна уу"
                                v-on:keyup.enter="search(searchValue)"
                                v-model="searchValue"
                            />
                        </div>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success btn-block" @click="search(searchValue)"><i class="mr-2 fas fa-search"></i>Хайх</button>
                    </div>
                </div>
                <div class="mb-3" v-if="searched && searchValue!=null && searchValue!=''">
                    <h4>
                        <div class="badge badge-pill badge-info">
                            {{searchValue}}
                            <i @click="searchValue=null;searched=false;_getStudents()" class="fas fa-times ml-2" style="cursor:pointer"></i>
                        </div>
                    </h4>
                </div>
                <div class="table-responsive" v-if="payments!=null && payments.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>КОД</th>
                        <th>ХЭРЭГЛЭГЧ</th>
                        <th>Төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(payment, index) in payments" v-bind:key="payment.id">
                            <td>{{index+1}}</td>
                            <td>{{payment.paidcode}}</td>
                            <td>
                                <span v-if="payment.user!=null">{{payment.user.id}}</span>
                                <span v-else>USER</span>
                                <br/>
                                <div v-if="payment.userData!=null">
                                    <h5>{{payment.userData.name}}</h5>
                                    
                                    <span>{{payment.userData.email}}</span>
                                </div>
                            </td>
                 
                            <td>
                                <span v-if="payment.paid==null || payment.paid==undefined || payment.paid==false" class="badge badge-danger">Not paid</span>
                                <span v-else class="badge badge-success">Paid</span>
                            </td>
                            <td>
                                <span v-if='payment.loading!=true'>
                                <button v-if="payment.paid==null || payment.paid==undefined || payment.paid==false" @click="submit(payment)" class="btn btn-warning btn-sm ml-2" >Эрх нээх</button>
                                </span>
                                <span v-else>
                                    <button type="button" class="btn btn-google btn-block" disabled>
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Loading..
                                    </button>
                                </span>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getStudentsData()" class="btn btn-success btn-block">Дараагийнх</button>
                        <button v-else type="button" class="btn btn-success btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор төлбөрийн мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    import firebase from 'firebase'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
               payments:[],
               lastVisible:null,
               loading:false,
               last:false,
               searchValue:null,
               searched:false,
               searchField:'paidcode',
               pageSize:20

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getStudents(){
                // fb.db.collection("lessons").where("published", "==", true).get().then(querySnapshot=> {
                //     console.log(querySnapshot.size);
                // });
                this.payments=[];
                this.getStudentsData();
            },
            submit(payment){
                payment.loading=true;
                var submitAnswerFunction = firebase.functions().httpsCallable('doPayment');
                var object={
                    user: payment.user.id,
                };
                submitAnswerFunction(
                    object
                ).then((result) => {
                    console.log(result);
                    if(result!=null && result.data==true){
                        payment.paid=true;
                    }
                    payment.loading=false;
                })
                .catch(function (error) {
                    console.log(error);
                    payment.loading=false;
                });
            },
            async getStudentsData(){
                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("payments").orderBy("createdAt",'asc').limit(this.pageSize);
                    
                    else
                        query=fb.db.collection("payments").orderBy("createdAt", 'asc').startAfter(this.lastVisible).limit(this.pageSize);
                    
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            object.loading=false;
                            object.userData=null;
                            if(doc.data().user!=null){
                                doc.data().user.get().then(userDoc=>{
                                    if(userDoc.exists)
                                        object.userData=userDoc.data();
                                });
                            }
                            this.payments.push(object);
                        });
                        if(documentSnapshots.size!=this.pageSize)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            },
            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.payments=[];
                    this.getStudentsDataByRegisterOrCode(value);
                }
                
            },
            async getStudentsDataByRegisterOrCode(value){

                    this.loading=true;
                    var query;
                    query=fb.db.collection("payments").where(this.searchField, "==", value);

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.payments.push(object);
                        });

                    }
                    this.loading=false;

            },

  
        },
        created() {
            this.students=[];

            this._getStudents();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
